import { ActivityName, MeasurementName, MeasurementUnit } from "../types";

export const MEASUREMENT_VALUE_TYPE = {
    [ActivityName.TEMPERATURE]: ["temperature"],
    [ActivityName.BLOOD_PRESSURE]: ["systolic", "diastolic"],
    [ActivityName.HEART_RATE]: ["heartRate"],
    [ActivityName.SPO2]: ["saturation"],
    [ActivityName.WEIGHT]: ["weight"],
    [ActivityName.ECG]: ["ecg"],
    [ActivityName.STEP]: ["step"],
    [ActivityName.DYSPNEA]: ["dyspnea"],
    [ActivityName.SPIROMETRY]: ["pef"]
}

export const MEASUREMENT_VALUE_UNIT: Record<MeasurementName, MeasurementUnit> = {
    [MeasurementName.TEMPERATURE]: MeasurementUnit.TEMPERATURE,
    [MeasurementName.DIASYSTOLIC]: MeasurementUnit.DIASYSTOLIC,
    [MeasurementName.SYSTOLIC]: MeasurementUnit.SYSTOLIC,
    [MeasurementName.HEART_RATE]: MeasurementUnit.HEART_RATE,
    [MeasurementName.SPO2]: MeasurementUnit.SPO2,
    [MeasurementName.WEIGHT]: MeasurementUnit.WEIGHT,
    [MeasurementName.ECG]: MeasurementUnit.ECG,
    [MeasurementName.STEP]: MeasurementUnit.STEP,
    [MeasurementName.DYSPNEA]: MeasurementUnit.DYSPNEA,
    [MeasurementName.PEF]: MeasurementUnit.PEF
}

export const ACTIVITY_MEASUREMENT_UNITS = {
    [ActivityName.TEMPERATURE]: {
        temperature: MeasurementUnit.TEMPERATURE
    },
    [ActivityName.BLOOD_PRESSURE]: {
        systolic: MeasurementUnit.SYSTOLIC,
        diastolic: MeasurementUnit.DIASYSTOLIC
    },
    [ActivityName.HEART_RATE]: {
        heartRate: MeasurementUnit.HEART_RATE
    },
    [ActivityName.SPO2]: {
        spo2: MeasurementUnit.SPO2
    },
    [ActivityName.WEIGHT]: {
        weight: MeasurementUnit.WEIGHT
    },
    [ActivityName.ECG]: {
        ecg: MeasurementUnit.ECG
    },
    [ActivityName.STEP]: {
        step: MeasurementUnit.STEP
    },
    [ActivityName.DYSPNEA]: {
        dyspnea: MeasurementUnit.DYSPNEA
    },
    [ActivityName.SPIROMETRY]: {
        pef: MeasurementUnit.PEF
    }
}